import React, { useState, useEffect, useContext } from 'react';
import axiosConn from '../../axiosConn';
import { AuthContext } from '../../context/AuthContext';
import { Table, Spinner, Alert } from 'react-bootstrap';

const BadgeRedemptions = ({ businessId }) => {
  const { player } = useContext(AuthContext);
  const [redemptions, setRedemptions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchBadgeRedemptions = async () => {
      try {
        const { data } = await axiosConn.get(
          `/badges/redemptions?businessId=${businessId}`,
          {
            headers: { Authorization: `Bearer ${player?.token}` },
          },
        );
        setRedemptions(data?.redemptions || []);
      } catch (err) {
        console.error('Failed to fetch badge redemptions:', err);
        setError('Unable to load badge redemptions.');
      } finally {
        setLoading(false);
      }
    };

    if (businessId && player?.token) {
      fetchBadgeRedemptions();
    }
  }, [businessId, player?.token]);

  if (loading) return <Spinner animation="border" variant="primary" />;
  if (error) return <Alert variant="danger">{error}</Alert>;
  if (!redemptions.length)
    return <Alert variant="info">No badge redemptions yet.</Alert>;

  return (
    <Table striped bordered hover responsive>
      <thead>
        <tr>
          <th>🏅 Badge</th>
          <th>Player</th>
          <th>Date</th>
        </tr>
      </thead>
      <tbody>
        {redemptions.map((r) => (
          <tr key={r._id}>
            <td>{r.badge?.name || 'Unnamed Badge'}</td>
            <td>{r.player?.playerId || 'Unknown Player'}</td>
            <td>{new Date(r.createdAt).toLocaleString()}</td>
          </tr>
        ))}
      </tbody>
    </Table>
  );
};

export default BadgeRedemptions;
